import { RootInitialState } from '@packages/shared/core/common/store/rootReducer';

export const getUtmTags = (state: RootInitialState) => state.userUtmTags.tags;

export const getUtmSource = (state: RootInitialState) => getUtmTags(state).utm_source;

export const getUtmAdName = (state: RootInitialState) => getUtmTags(state).utm_ad_name;
